import { render, staticRenderFns } from "./wyUpdate.vue?vue&type=template&id=006f5f73&scoped=true"
import script from "./wyUpdate.vue?vue&type=script&lang=js"
export * from "./wyUpdate.vue?vue&type=script&lang=js"
import style0 from "./wyUpdate.vue?vue&type=style&index=0&id=006f5f73&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006f5f73",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('006f5f73')) {
      api.createRecord('006f5f73', component.options)
    } else {
      api.reload('006f5f73', component.options)
    }
    module.hot.accept("./wyUpdate.vue?vue&type=template&id=006f5f73&scoped=true", function () {
      api.rerender('006f5f73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/fixOrder/wyUpdate.vue"
export default component.exports